module.exports = __webpack_public_path__ + "media/images/logo-min-50bdf62eb96002b5d54a271d33a9f601.png";